import { Component } from 'react'
import { reaction } from 'mobx'
import { observer } from 'mobx-react'

import * as h from 'h'
import { filterRequestsByNamespace } from 'utils'

import { PopoutTransitionContainer } from 'components/Popout/PopoutTransitionContainer'
import StoryModel from 'models/StoryModel'
import Filters from './Filters'
import Stories from './Stories'

import styles from './styles.scss'

@observer(['UiStore', 'StoryStore'])
export default class NewsEvents extends Component {
  constructor () {
    super()
    this.routeChangeAutorun = null
  }

  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------

  componentDidMount () {
    this.props.StoryStore.startFetcher()

    // If route changes (ex. news to events),
    // then restart fetcher (given new type)
    this.routeChangeAutorun = reaction(
      () => [
        this.props.UiStore.route
      ],
      () => {
        this.props.StoryStore.stopFetcher()
        this.props.StoryStore.startFetcher()
      }
    )
  }

  componentWillUnmount () {
    this.props.StoryStore.stopFetcher()

    // Dispose route change autorun
    if (this.routeChangeAutorun) {
      this.routeChangeAutorun()
    }
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  addTag = (tag) => {
    this.props.UiStore.storyFilters.tags.push(tag)
  }

  togglePastStories = () => {
    this.props.StoryStore.togglePastStories()
  }

  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------

  filterStoriesByTags (stories) {
    return this.tags.length === 0
      ? stories
      : stories.filter(story => this.tags.some(tag => story.tags.includes(tag)))
  }
  get type () {
    return this.props.UiStore.route === 'news' ? 'news' : 'events'
  }

  get stories () {
    const { StoryStore: { stories } } = this.props

    return this.filterStoriesByTags(stories)
  }

  get pastStories () {
    const { StoryStore: { stories } } = this.props
    const now = new Date()
    return this.filterStoriesByTags(stories.filter(story => story.expirationDate < now)
                                           .sort(StoryModel.descendingDateComparator))
  }

  get futureStories () {
    const { StoryStore: { stories } } = this.props
    const now = new Date()
    return this.filterStoriesByTags(stories.filter(story => story.expirationDate > now)
                                           .sort(StoryModel.ascendingDateComparator))
  }

  get availableTags () {
    return this.props.StoryStore.availableTags
  }

  get tags () {
    return this.props.UiStore.storyFilters.tags
  }

  get isRequesting () {
    return filterRequestsByNamespace(this.props.UiStore.requests, `${this.type}`).length > 0
  }

  get renderNews () {
    return h.h(Stories, {
      stories: this.stories,
      addTag: this.addTag,
      isRequesting: this.isRequesting
    })
  }

  get renderEvents () {
    return h.div(null,
      h.h(Stories, {
        stories: this.props.StoryStore.hidePastStories
          ? this.futureStories
          : this.futureStories.concat(this.pastStories),
        addTag: this.addTag,
        isRequesting: this.isRequesting
      }),
      this.pastStories.length > 0 &&
        h.button({
          ...h.ca(styles.btn, styles.togglePastStoriesBtn),
          type: 'button',
          onClick: this.togglePastStories
        },
        (this.props.StoryStore.hidePastStories ? 'Show' : 'Hide') + ' Past Events'))
  }

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------

  render () {
    return h.div(styles.wrapper,
      h.h(PopoutTransitionContainer, null, this.props.children),
      h.h(Filters, {
        availableTags: this.availableTags,
        onTagsChange: active => { this.props.UiStore.storyFilters.tags = active }
      }),
      this.type === 'news' && this.renderNews,
      this.type === 'events' && this.renderEvents
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/NewsEvents/index.js